import { Children, forwardRef } from 'react';
import { s } from '../../theme/tokens';
import { Box } from '../primitives/Box';
import type { SpacingToken } from '../../theme/tokens';
import type { BoxProps } from '../primitives/Box';

export type StackProps = Omit<BoxProps, 'gap'> & {
  gap?: SpacingToken;
  align?: BoxProps['alignItems'];
  direction?: BoxProps['flexDirection'];
  justify?: BoxProps['justifyContent'];
  wrap?: BoxProps['flexWrap'];
};

export const Stack = forwardRef<HTMLDivElement, StackProps>(
  (
    {
      gap = 'md',
      align,
      direction,
      justify,
      wrap,
      children,
      alignItems,
      justifyContent,
      flexWrap,
      sx,
      ...rest
    }: StackProps,
    ref,
  ): JSX.Element => (
    <Box
      ref={ref}
      sx={[
        {
          display: 'flex',
          flexDirection: direction ?? 'column',
          alignItems: align ?? alignItems,
          justifyContent: justify ?? justifyContent,
          flexWrap: wrap ?? flexWrap,
          gap: s(gap),
          minWidth: 0,
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
      {...rest}
    >
      {Children.toArray(children)}
    </Box>
  ),
);

Stack.displayName = 'Stack';
